// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","links":"Footer_links__2VAlO","courses":"Footer_courses__jAOLu","media":"Footer_media__41fb3","footer_info":"Footer_footer_info__1+z6T"};